import React from 'react';

const BrandLogo = ({ alt = 'TLK', className, style, transparent = false }) => (
  transparent ? (
    <img src="/logo-transparent.svg" alt={alt} className={className} style={style} />
  ) : (
    <picture>
      <source srcSet="/logo-light.svg" media="(prefers-color-scheme: light)" />
      <img src="/logo-dark.svg" alt={alt} className={className} style={style} />
    </picture>
  )
);

export default BrandLogo;
